import { Dispatch, RefObject, useEffect } from "react";

export default function useCloseWhenClickedOutside({
	refs,
	setState,
}: {
	refs: RefObject<HTMLDivElement | HTMLButtonElement | HTMLUListElement | null>[]
	setState: Dispatch<React.SetStateAction<boolean>>;
}) {
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			const target = event.target as Node;

			const isClickOutsideAllElements = refs.every(
				(ref) => {
                    const isClickOutsideElement = ref.current && !ref.current.contains(target);
                    return isClickOutsideElement
                }
			);

			if (isClickOutsideAllElements) {
				setState(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [refs]);
}